import React from 'react'
import { CardFooter } from '../bootstrap/Card'
import Card, {
    CardBody, CardHeader, CardLabel, CardTitle, CardActions
} from '../bootstrap/Card';
import Button from '../bootstrap/Button';

export const TrackerBoardEmailBlastOtherAttachment = ({ attachment, setAttachment, deleteAttachment, enabled = true }) => {
    return (
        <Card>
            <CardHeader>
                <CardLabel>
                    <CardTitle>
                        {attachment?.title}
                    </CardTitle>
                </CardLabel>
                {enabled && <CardActions>
                    <Button icon="XLg"
                        onClick={() => deleteAttachment()}
                    />
                </CardActions>}
            </CardHeader>
        </Card>
    )
}
